module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements"
  }, [_vm._v("To my literary agent extraordinaire, "), _c('strong', [_vm._v("ANGELA MILLER")]), _vm._v(", for championing the art of storytelling.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements"
  }, [_vm._v("To "), _c('strong', [_vm._v("BILL LEBLOND")]), _vm._v(" and "), _c('strong', [_vm._v("AMY TREADWELL")]), _vm._v(", for believing in my voice and vision. And for "), _c('strong', [_vm._v("SUPRIYA KALIDAS")]), _vm._v(" for guiding my creative spirit—and love of good food—in such a cool and stylish way.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements"
  }, [_vm._v("To "), _c('strong', [_vm._v("REBECCA SHERMAN")]), _vm._v(", for always being there to help me get my publishing projects not just up on their feet, but running.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements"
  }, [_vm._v("To "), _c('strong', [_vm._v("JOY & KIRK KIRKSEY")]), _vm._v(", for sharing some cool casserole wares for photography.")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements"
  }, [_vm._v("And to my husband, "), _c('strong', [_vm._v("ROBERT PEACOCK")]), _vm._v(", whose love of food and family truly shines.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ddef746","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_acknowledgments.vue
// module id = 75
// module chunks = 0